
const companyRoutes = [
  {
    path: '/company/attention',
    name: 'companyAttention',
    component: () => import(/* webpackChunkName: "companyAttention" */ '@/views/company/attention/index.vue'),
    meta: {
      title: "关注厂家",
      keepAlive: true,
    },
  },
  {
    path: '/company/about/:id',
    name: 'comaboutAbout',
    component: () => import(/* webpackChunkName: "comaboutAbout" */ '@/views/company/about/index.vue'),
    meta: {
      title: "关于我们",
      keepAlive: true,
    },
  },
  {
    path: '/company/contact/:id',
    name: 'comaboutContact',
    component: () => import(/* webpackChunkName: "comaboutContact" */ '@/views/company/contact/index.vue'),
    meta: {
      title: "联系我们",
      keepAlive: true,
    },
  },
  {
    path: '/company/home/:id',
    name: 'compHome',
    component: () => import(/* webpackChunkName: "compHome" */ '@/views/company/home/index.vue'),
    meta: {
      title: "公司首页",
    },
  },
  {
    path: '/company/lecto/:id',
    name: 'comaboutLecto',
    component: () => import(/* webpackChunkName: "comaboutLecto" */ '@/views/company/lecto/index.vue'),
    meta: {
      title: "分类选型",
      keepAlive: true,
    },
  },
];

export default companyRoutes;
